import { getTracking } from '@moda/portal-astrarium';
import { dictionary } from './ecomDictionary';

export const tc = getTracking(dictionary);
